import React, { FC } from 'react';

import useTranslation from '../../../hooks/useTranslation';
import CookieForm from '../../components/cookie-form/CookieForm';

const Form: FC = () => {
    const { modal, cookies } = useTranslation();

    return (
        <div className="card standard-card left-adjusted">
            <div className="card-content">
                <div className="card-wrap">
                    <h2>{modal.header}</h2>
                    <p className="consent-subheader">{modal.subHeader}</p>
                    <CookieForm cookies={cookies} />
                </div>
            </div>
        </div>
    );
};

export default Form;
